import { COLORS } from 'modules/core/theme/colors';
import { StylesConfig } from 'react-select';

const BLUE = 'rgba(13,110,253,.25)';
const LIGHT_BLUE = '#86b7fe';
const RED_SHADOW = '0 0 0 .25rem rgba(220,53,69,.25)';
const BLUE_SHADOW = `0 0 0 .25rem ${BLUE}`;
const BORDER_COLOR = 'var(--bs-border-color-translucent)';

export const selectStyles = function (
  isInvalid: boolean,
  currentMenuPlacement: string,
  setCurrentMenuPlacement: React.Dispatch<React.SetStateAction<string>>,
): StylesConfig {
  return {
    control: (styles: any, state) => ({
      ...styles,
      borderRadius: 'var(--bs-modal-border-radius)',
      borderColor: isInvalid ? COLORS.RED_6 : state.isFocused ? LIGHT_BLUE : BORDER_COLOR,
      boxShadow: state.isFocused ? (isInvalid ? RED_SHADOW : BLUE_SHADOW) : 'none',
      ':active': {
        borderColor: isInvalid ? COLORS.RED_6 : BLUE,
        boxShadow: isInvalid ? RED_SHADOW : BLUE_SHADOW,
      },
      ':hover': {
        borderColor: isInvalid ? COLORS.RED_6 : BORDER_COLOR,
      },
    }),
    menu: (styles, state) => {
      setCurrentMenuPlacement(state.placement);

      return { ...styles, zIndex: 9999 };
    },
    dropdownIndicator: (styles: any, state) => ({
      ...styles,
      transition: 'all .2s ease',
      transform: state.selectProps.menuIsOpen && currentMenuPlacement === 'top' ? 'rotate(180deg)' : null,
    }),
  };
};
